export default __webpack_public_path__ + "static/media/Bottom_appointment_selected.09c9ae4f.svg";